import { render } from "./ErklaerungPopUp.vue?vue&type=template&id=0cd65344&scoped=true"
import script from "./ErklaerungPopUp.vue?vue&type=script&lang=js"
export * from "./ErklaerungPopUp.vue?vue&type=script&lang=js"

import "./ErklaerungPopUp.vue?vue&type=style&index=0&id=0cd65344&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd65344"]])

export default __exports__